
export default {
  props: {
    documents: {
      type: Array,
      required: true,
    },
  },
}
